import React from 'react';
import usePositionMode from '../hooks/usePositionMode';

// "With All Shorts" was retired Apr 2026 — the upstream report folder
// (transactions_gross_with_shorts) is no longer generated. Shorts shown in
// the admin are exclusively the ML-recommended ones.
const OPTIONS = [
  { key: 'long_only', label: 'Long Only', activeBg: 'bg-emerald-600' },
  { key: 'rec_shorts', label: 'With Rec. Shorts', activeBg: 'bg-orange-600' },
];

/**
 * Shared "Positions" segmented control.
 *
 * Renders nothing for users without shorts permission so the page looks
 * exactly as it did before this feature for everyone else. Drop it next to
 * your existing Strategy/Market filters on any page that pulls report data.
 */
export default function PositionModeToggle({ label = 'Strategy', className = '' }) {
  const { mode, setMode, canUseShorts } = usePositionMode();
  if (!canUseShorts) return null;

  return (
    <div className={className}>
      <label className="block text-xs font-semibold text-dark-400 uppercase tracking-wide mb-1.5">
        {label}
      </label>
      <div className="flex items-center bg-dark-700 rounded-lg p-1">
        {OPTIONS.map(opt => (
          <button
            key={opt.key}
            type="button"
            onClick={() => setMode(opt.key)}
            className={`px-3 py-1.5 rounded text-sm font-semibold transition-all ${
              mode === opt.key ? `${opt.activeBg} text-white shadow-sm` : 'text-dark-400 hover:text-white'
            }`}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
